import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError, } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class CashBankTransactionService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

  getMaxId() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/cash-bank-transaction/getMaxId`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

  getAll():Observable <any[]> {
  return this.http.get<any[]>(`${this.env.apiUrl}/cash-bank-transaction`,httpOptions)
  .pipe(catchError(this.handleError));      
  }

  addCashBankEntry(data):Observable <any>{
    return this.http.post<any>(`${this.env.apiUrl}/cash-bank-transaction`,  data ,httpOptions)
      .pipe(catchError(this.handleError));
     
  }
 

  deleteCashBankEntry(id: string) : Observable <void>{
    return this.http.delete<void>(`${this.env.apiUrl}/cash-bank-transaction/${id}`,httpOptions)
      .pipe(catchError(this.handleError));
     
  }

  getAllCashBal():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/cash-bank-transaction/getAllCashBal`,httpOptions)
    .pipe(catchError(this.handleError));      
    }

private handleError(errorResponse: HttpErrorResponse) {
  return throwError(errorResponse || "Server Error");
  }

}
